<div class="row messenger-container" [ngClass]="{show:show}">
	<div class="col d-flex justify-content-center">
		<app-sticky-ball *ngFor="let channel of latestChannels" class="mx-3" [channel]="channel" [mode]="'channel'"
			[canShowRightPane]="show" (onShowRightPane)="onShowRightPaneHandle($event, channel.id)"
			[ngClass]="{bounce:whoWantsToBounce==channel.id}">
		</app-sticky-ball>
		<!-- <app-sticky-ball class="mx-3" (onShowRightPane)="onShowRightPaneHandle($event, 0)" [mode]="'bot'">
		</app-sticky-ball> -->
	</div>
</div>